import React, { createContext, useContext, FC, ReactNode, useMemo } from 'react'
import { StoreSelectorProps } from '../StoreSelector'
import { CreditAmountProps } from '../CreditAmount/CreditAmount.experiment'

type HeaderConfigContextValue = {
  storeSelectorConfig: StoreSelectorProps | null
  experimentCreditAmountConfig: CreditAmountProps | null
}

const HeaderConfigContext = createContext<HeaderConfigContextValue | null>(null)

type HeaderConfigProviderProps = {
  storeSelectorConfig?: StoreSelectorProps
  experimentCreditAmountConfig?: CreditAmountProps
  children: ReactNode
}

export const HeaderConfigProvider: FC<HeaderConfigProviderProps> = ({
  storeSelectorConfig,
  experimentCreditAmountConfig,
  children,
}) => {
  const value: HeaderConfigContextValue = useMemo(
    () => ({
      storeSelectorConfig: storeSelectorConfig || null,
      experimentCreditAmountConfig: experimentCreditAmountConfig || null,
    }),
    [storeSelectorConfig, experimentCreditAmountConfig],
  )

  return (
    <HeaderConfigContext.Provider value={value}>
      {children}
    </HeaderConfigContext.Provider>
  )
}

export const useStoreSelectorConfig = (): StoreSelectorProps | null => {
  const context = useContext(HeaderConfigContext)
  if (!context) {
    throw new Error(
      'useStoreSelectorConfig must be used within the HeaderConfigProvider',
    )
  }
  return context.storeSelectorConfig
}

export const useExperimentCreditAmountConfig = (): CreditAmountProps | null => {
  const context = useContext(HeaderConfigContext)
  if (!context) {
    throw new Error(
      'useExperimentCreditAmountConfig must be used within the HeaderConfigProvider',
    )
  }
  return context.experimentCreditAmountConfig
}
